/**
 * 一个临时的Vue，用于弹出ElementUI弹窗
 */

import ElementUI from 'element-ui';
import Vue from 'vue'
Vue.use(ElementUI);

let vueTemp = new Vue();

export default vueTemp



// WEBPACK FOOTER //
// ./src/common/vueTemp.js